module.exports = __webpack_public_path__ + "img/fish5.34731cdd.png";